import React from 'react';
import { NFT_EXPLORER_COLS } from './index';
import { lowerCase, upperFirst } from 'lodash';
import { NFTCollection } from './types';
import { NFTAddress, NFTBlockchain, NFTDiff, NFTspanWithIcon } from './Utils';
import { Icon } from '../../UI';

interface CollectionDetailsProps {
  goBack: () => void;
  collectionData: NFTCollection;
}

const DetailWrapper = ({ children, columnName }) => {
  return (
    <div className={'flex flex-col'}>
      <p className={'text-xs font-medium mb-1'}>{columnName}</p>
      <div>{children}</div>
    </div>
  );
};

const CollectionDetails: React.FC<CollectionDetailsProps> = ({
  collectionData,
  goBack,
}) => {
  const { address, volume, name, floorAskPrice, floorSale, imageUrl } =
    collectionData;

  const blockchain = address.startsWith('0x') ? 'Ethereum' : 'Solana';
  const values = [
    // 'BLOCKCHAIN'
    <NFTBlockchain isDetailsView />,
    // 'FLOOR PRICE'
    <NFTspanWithIcon isDetailsView>{floorAskPrice}</NFTspanWithIcon>,
    // 'ATH'
    <NFTspanWithIcon>-</NFTspanWithIcon>,
    // 'AVG.PRICE(7D)'
    <NFTDiff start={floorSale.oneDay} end={floorSale.sevenDay} isDetailsView />,
    // 'VOLUME(7D)'
    <NFTDiff start={volume.oneDay} end={volume.sevenDay} isDetailsView />,
    // 'LAST SALE'
    <NFTspanWithIcon>-</NFTspanWithIcon>,
    // 'CREATION DATE'
    <div>-</div>,
    // 'OWNERS'
    <div>-</div>,
    // 'SUPPLY'
    <div>-</div>,
    // 'ADDRESS'
    <NFTAddress isDetailsView address={address} blockchain={blockchain}>
      {address}
    </NFTAddress>,
  ];
  return (
    <div className={'w-full h-full flex flex-col'}>
      <div className="flex items-center border-b border-grey-10 py-2 px-4 gap-3 dark:border-grey-70">
        <Icon svgName="arrowBack" className="cursor-pointer" onClick={goBack} />
        <img
          src={imageUrl}
          alt="collection avatar"
          className="w-12 h-12 object-cover rounded-full"
        />
        <p className="font-semibold text-base -mx-1">{name}</p>
      </div>
      <div className={'px-5 py-3 overflow-y-scroll h-full flex flex-col gap-7'}>
        {NFT_EXPLORER_COLS.slice(1).map((column, i) => {
          return (
            <DetailWrapper columnName={upperFirst(lowerCase(column))}>
              {values[i]}
            </DetailWrapper>
          );
        })}
      </div>
    </div>
  );
};

export default CollectionDetails;
